export default Object.freeze([
  {
    text: 'Трудовая эксплуатация',
    value: '0',
  },
  {
    text: 'Сексуальная эксплуатация',
    value: '1',
  },
])
